import ReactDOM from 'react-dom/client'

import { App } from '@/App.tsx'
import { getPageTitlePrefix, initializeSentry } from '@/config.ts'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

initializeSentry()
getPageTitlePrefix()

root.render(<App />)
